import { render, staticRenderFns } from "./AddCommissionModal.vue?vue&type=template&id=be8815e6"
import script from "./AddCommissionModal.vue?vue&type=script&lang=js"
export * from "./AddCommissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports